import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import {modifyZajavl} from '@componentDP/js_react/redux/actions/zajavls';
import {withTranslation} from "react-i18next";

class NeedHostel extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {
        const {zajavl, modifyZajavl} = this.props;
        modifyZajavl(zajavl.uuid, {is_need_hostel: e.target.checked ? 1 : 0});
    }
    render() {
        const {handleChange} = this;
        const {zajavl, t} = this.props;
        return(
            <FormControlLabel
                control={
                    <Checkbox
                        checked={zajavl.is_need_hostel === 1}
                        onChange={handleChange}
                        color="primary"
                        name="is_need_hostel"
                        disabled={zajavl.is_save_without_send_allowed  === false && zajavl.is_save_and_send_allowed === false}
                    />
                }
                label={t('need_dorm')} />
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        modifyZajavl,
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(NeedHostel));
